var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.907 5.586a1.434 1.434 0 0 0-1.012-.424H26.3c-1.818.007-5.817-.171-9.276-2.865a1.426 1.426 0 0 0-1.744 0C11.82 4.991 7.822 5.17 6.01 5.162h-.588a1.45 1.45 0 0 0-1.018.424c-.267.273-.41.642-.404 1.018.075 4.827.28 8.306.69 10.966.308 1.99.725 3.527 1.34 4.799a8.577 8.577 0 0 0 1.676 2.405c.984.998 2.112 1.689 3.363 2.414l.697.396c1.07.608 2.253 1.278 3.595 2.173.479.32 1.1.32 1.58 0 1.321-.885 2.488-1.548 3.55-2.15l.002-.002c.496-.282.97-.55 1.424-.823 1.067-.635 2.044-1.306 2.899-2.229a9.152 9.152 0 0 0 1.613-2.508c.65-1.484 1.08-3.316 1.368-5.784.293-2.468.45-5.585.52-9.66a1.43 1.43 0 0 0-.41-1.018zM24.81 17.139c-.28 1.818-.65 3.082-1.094 3.998a6.05 6.05 0 0 1-1.141 1.648c-.663.67-1.552 1.244-2.756 1.935-.236.137-.484.277-.742.424l-.003.002a64.19 64.19 0 0 0-2.92 1.735 63.894 63.894 0 0 0-2.967-1.757l-.003-.001a62.885 62.885 0 0 1-1.337-.77c-.977-.588-1.695-1.101-2.262-1.723a6.08 6.08 0 0 1-1.101-1.724c-.485-1.1-.875-2.666-1.149-4.977-.239-2.031-.39-4.615-.464-7.938 2.126-.068 5.79-.479 9.283-2.823 3.494 2.35 7.158 2.76 9.29 2.822-.095 4.02-.3 6.973-.635 9.147z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwt);
export default __webpack_public_path__ + "static/media/TWT.3a0e3c7bb89c4ce4d5f8463979528db9.svg";
export { ForwardRef as ReactComponent };